import DistributionsTable from "./DistributionsTable"

export default DistributionsTable
